// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3U6LO","title":"BackImages_title__3zndj","images":"BackImages_images__3um2P"};